import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    WatermarkDataPointUserName: string;
    WatermarkDataPointEmail: string;
    WatermarkDataPointIpAddress: string;
    WatermarkDataPointTimestamp: string;
    WatermarkDataPointCustomText: string;
    WatermarkDataPointUserInput: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for viewer name in template descriptions */
            WatermarkDataPointUserName: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFriendlyTemplateData.WatermarkDataPointUserName?c=225ge594d9ejj", defaultMessage: "Name" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for viewer email in template descriptions */
            WatermarkDataPointEmail: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFriendlyTemplateData.WatermarkDataPointEmail?c=ogaduaowhuca", defaultMessage: "Email" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for viewer IP address in template descriptions */
            WatermarkDataPointIpAddress: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFriendlyTemplateData.WatermarkDataPointIpAddress?c=csn2b189h1q3", defaultMessage: "IP address" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for timestamp in template descriptions */
            WatermarkDataPointTimestamp: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFriendlyTemplateData.WatermarkDataPointTimestamp?c=6un4aypyrkjj", defaultMessage: "Date & Time" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for admin-defined custom text in template descriptions */
            WatermarkDataPointCustomText: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFriendlyTemplateData.WatermarkDataPointCustomText?c=niw51223nicx", defaultMessage: "Custom Text" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for share creator custom text in template descriptions */
            WatermarkDataPointUserInput: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "getFriendlyTemplateData.WatermarkDataPointUserInput?c=2g4sunmavzf9z", defaultMessage: "Share creator''s custom text" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
